import React from "react";

// Import the DelayedActionToast component to extract its props type
import type { DelayedActionToast } from "@swiggy-private/dls-web-recipe-food-web/dist/components/DelayedActionToast";

/**
 * Extract props type from the DLS DelayedActionToast component
 * This avoids duplicating the interface definition
 */
export type DelayedActionToastProps = React.ComponentProps<typeof DelayedActionToast>;

/**
 * Action types for toast state management
 */
export enum ToastActionType {
    SHOW_TOAST = "SHOW_TOAST",
    HIDE_TOAST = "HIDE_TOAST",
}

/**
 * Simple state interface for toast management
 * Only tracks visibility and props - DLS component handles its own internal state
 */
export interface ToastState {
    isVisible: boolean;
    props: DelayedActionToastProps;
    style?: React.CSSProperties;
}

/**
 * Action interfaces for reducer
 */
export interface ShowToastAction {
    type: ToastActionType.SHOW_TOAST;
    payload: Omit<ToastState, "isVisible">;
}

export interface HideToastAction {
    type: ToastActionType.HIDE_TOAST;
}

export type ToastAction = ShowToastAction | HideToastAction;

export interface DelayedActionToastContextType {
    dispatch: React.Dispatch<ToastAction>;
    toastState: ToastState | null;
}
